import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { PatientService } from 'services/patient';
import { type GetPatientRecordsParams, type PatientRecord } from 'types/patient';

export const useFetchPatientRecords = (
  patientId: string,
  params?: GetPatientRecordsParams
): UseQueryResult<PatientRecord[]> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_PATIENT_RECORDS, patientId, params?.contractId, params?.status],
    queryFn: async () => PatientService.getRecords(patientId, params),
    select: response => response.data,
    enabled: Boolean(patientId),
  });
